import React, { useContext, useEffect } from "react";
import styles from "./Partners.module.scss";
import { Context } from "../../Store";
import vector2 from "../../../imgs/vector2.png";
import background2L from "../../../imgs/background2l.png";
import background2R from "../../../imgs/background2r.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from "swiper";
import Loading from "../../Loading/Loading";

const Partners = () => {
  let {
    dir,
    setIsClicked,
    partnersSection,
    partnersRes,
    partnersResData,
    partnersLoading,
  } = useContext(Context);
  let { title, subTitle } = partnersResData;
  useEffect(() => {
    setIsClicked(false);
  }, [setIsClicked]);
  return (
    <section ref={partnersSection} id={styles.partners}>
      {dir === "ltr" ? (
        <img src={background2L} className={styles.background2L} alt="" />
      ) : (
        <img src={background2R} className={styles.background2R} alt="" />
      )}
      <img
        className={
          dir === "ltr" ? `${styles.vectorimgLtr}` : `${styles.vectorimgRtl}`
        }
        src={vector2}
        alt=""
      />
      <div className={styles.container}>
        {partnersLoading ? (
          <Loading />
        ) : (
          <>
            <div className={styles.item0}>
              <h2>{title}</h2>
              <p>{subTitle}</p>
            </div>
            {/* <div className={styles.item1}>
                <img className={styles.partnerImg} src={partner0} alt="" />
                <img className={styles.partnerImg} src={partner1} alt="" />
                <img className={styles.partnerImg} src={partner2} alt="" />
                <img className={styles.partnerImg} src={partner3} alt="" />
                <img className={styles.partnerImg} src={partner4} alt="" />
                <img className={styles.partnerImg} src={partner5} alt="" />
            </div> */}
            <div className={styles.item2}>
              <Swiper
                dir="rtl"
                slidesPerView={4}
                spaceBetween={60}
                slidesPerGroup={1}
                loop={true}
                loopFillGroupWithBlank={true}
                modules={[Autoplay]}
                autoplay={{
                  delay: 2000,
                  disableOnInteraction: false,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    slidesPerGroup: 1,
                  },
                  1200: {
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                  },
                }}
              >
                {partnersRes.map((partner) => (
                  <SwiperSlide key={partner.id}>
                    <div className={styles.partnerImg}>
                      <img src={partner.logo} alt="" />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </>
        )}
      </div>
    </section>
  );
};

export default Partners;
